import React from 'react';

import { Link, useNavigate } from 'react-router-dom';
import { SessionState, logoutUser } from 'features/session/sessionSlice';
import { cleanFavorites, cleanNextSteps } from 'features/user/userSlice';
import { useAppDispatch, useAppSelector } from 'app/hooks';
// import { useRemoveLoginMutation } from 'services/exploreApi';
import { navigateTop, userInitials } from 'common/utils';
import Text from 'common/components/Text/Text';

import styles from './AppNavbar.module.scss';
import textStyles from 'common/styles/text.module.scss';
import { SchoolIcon, ProgramIcon, Logo, Menu, X } from 'assets/landing/index';
import { SettingsIcon } from 'assets/session/dashboard/index';
import Dropdown from 'react-bootstrap/Dropdown';
import { Country } from 'app/types';
import { useGetCountriesQuery } from 'services/exploreApi';
import { detailUrl } from 'common/utils/conversions';

interface CompProps {
  setIsNavCollapsed: (collapsed: boolean) => void;
  isNavCollapsed: boolean;
  isLanding: boolean;
}

const MobileMenu = ({
  isLanding,
  setIsNavCollapsed,
  isNavCollapsed,
}: CompProps): React.ReactElement => {
  const { logged, user, profile } = useAppSelector(
    ({ session }: { session: SessionState }) => session
  );
  const { data: countries } = useGetCountriesQuery({
    page: 0,
  });
  // const [removeLogin] = useRemoveLoginMutation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const navigateTo = (route: string) => {
    navigate(route);
    setIsNavCollapsed(!isNavCollapsed);
  };
  const logout = () => {
    // removeLogin();
    dispatch(cleanFavorites());
    dispatch(logoutUser());
    setIsNavCollapsed(!isNavCollapsed);
    dispatch(cleanNextSteps());
    navigate('/');
    navigateTop();
  };

  const renderShortlist = () => {
    setIsNavCollapsed(!isNavCollapsed);
    navigate('/home');
    setTimeout(() => {
      navigateTop(0, 0, 'topics');
    }, 100);
  };

  const renderMyapplications = () => {
    setIsNavCollapsed(!isNavCollapsed);
    navigate('/home');
    setTimeout(() => {
      navigateTop(0, 0, 'topics');
    }, 100);
  };

  return (
    <div className={`container-fluid ${isLanding ? styles.landingBG : ''}`}>
      {!isLanding && (
        <div className={`d-flex flex-row justify-content-between ${styles.navContainer}`}>
          {logged && (
            <div className={styles.userInfoContainer}>
              <div className={styles.userAvatar}>
                {user?.photo ? (
                  <img src={user?.photo} className={styles.userAvatarImg}></img>
                ) : (
                  userInitials(user)
                )}
              </div>
              <div className={styles.userInfo}>
                <Text size={20} weight={500}>
                  {user?.name}
                </Text>
                <Text size={12} color="secondary">
                  {user?.email}
                </Text>
              </div>
            </div>
          )}
          <button
            className={`navbar-toggler ${styles.menuLogo}`}
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded={!isNavCollapsed ? true : false}
            aria-label="Toggle navigation"
            onClick={() => setIsNavCollapsed(!isNavCollapsed)}
          ></button>
        </div>
      )}
      <div className={styles.mobileMenuContainer}>
        {!logged && <hr />}
        {logged && (
          <div className={styles.section}>
            <div className={styles.title}>
              <p className={textStyles['text-primary-16-600']}>Account</p>
            </div>
            <div className={styles.rowBtwn} onClick={() => navigateTo('home/personal_information')}>
              <div className={styles.row}>
                <i className="bi bi-person-square"></i>
                <p className={textStyles['text-primary-16-500']}>My Profile</p>
              </div>
              <div>
                <i className={`bi bi-chevron-right ${styles.vector}`}></i>
              </div>
            </div>
            <div
              className={styles.rowBtwn}
              onClick={() => {
                navigateTo('/home/preferences');
                navigateTop();
              }}
            >
              <div className={styles.row}>
                <i className="bi bi-clipboard2"></i>
                <p className={textStyles['text-primary-16-500']}>My Preference</p>
              </div>
              <div>
                <i className={`bi bi-chevron-right ${styles.vector}`}></i>
              </div>
            </div>
            <div className={styles.rowBtwn} onClick={renderMyapplications}>
              <div className={styles.row}>
                <i className="bi bi-pencil-square"></i>
                <p className={textStyles['text-primary-16-500']}>My Application</p>
              </div>
              <div>
                <i className={`bi bi-chevron-right ${styles.vector}`}></i>
              </div>
            </div>
            <div className={styles.rowBtwn} onClick={renderShortlist}>
              <div className={styles.row}>
                <i className="bi bi-heart"></i>
                <p className={textStyles['text-primary-16-500']}>My Shortlist</p>
              </div>
              <div>
                <i className={`bi bi-chevron-right ${styles.vector}`}></i>
              </div>
            </div>
            <div
              className={styles.rowBtwn}
              onClick={() => {
                navigateTo('/personal-statement-builder');
                navigateTop();
              }}
            >
              <div className={styles.row}>
                <i className="bi bi-file-earmark-text"></i>
                <p className={textStyles['text-primary-16-500']}>My personal statements</p>
              </div>
              <div>
                <i className={`bi bi-chevron-right ${styles.vector}`}></i>
              </div>
            </div>
            <hr />
          </div>
        )}
        <div className={styles.section}>
          <div className={styles.title}>
            <p className={textStyles['text-primary-16-600']}>Study Abroad</p>
          </div>
          <div className={styles.rowBtwn} onClick={() => navigateTo('explore/programs')}>
            <div className={styles.row}>
              <i className="bi bi-mortarboard"></i>
              <p className={textStyles['text-primary-16-500']}>Programs</p>
            </div>
            <div>
              <i className={`bi bi-chevron-right ${styles.vector}`}></i>
            </div>
          </div>
          <div className={styles.rowBtwn} onClick={() => navigateTo('explore')}>
            <div className={styles.row}>
              {/* <img src={SchoolIcon} className={styles.icon} alt="school_icon" /> */}
              <i className="bi bi-building"></i>
              <p className={textStyles['text-primary-16-500']}>Universities</p>
            </div>
            <div>
              <i className={`bi bi-chevron-right ${styles.vector}`}></i>
            </div>
          </div>
          <Dropdown>
            <Dropdown.Toggle className={styles.rowCountries}>
              <div className={styles.row}>
                {/* <img src={SchoolIcon} className={styles.icon} alt="school_icon" /> */}
                <i className="bi bi-globe"></i>
                <p className={textStyles['text-primary-16-500']}>Destinations</p>
              </div>
              <div>
                <i className={`bi bi-chevron-right ${styles.vector}`}></i>
              </div>
            </Dropdown.Toggle>
            <Dropdown.Menu className={styles.exploreSubmenuCountriesMobile}>
              <Text size={14} weight={500} inlineStyle={{ color: '#727D9B', padding: '10px' }}>
                Popular destinations
              </Text>
              {countries?.data.slice(0, 8).map((country: Country) => (
                <Dropdown.Item
                  key={country.id}
                  className={styles.dropdownItem}
                  onClick={() => navigateTo(detailUrl('countries', country.id, country.name))}
                >
                  <div className={styles.itemProgramInfo}>
                    <Text
                      size={14}
                      weight={500}
                      inlineStyle={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {country.name}
                    </Text>
                  </div>
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
        {!profile && (
          <div className={styles.rowBtwn} onClick={() => navigateTo('/profile')}>
            <hr />
            <div className={styles.row}>
              <p className={textStyles['text-primary-16-500']}>Course Match</p>
            </div>
            <div>
              <i className={`bi bi-chevron-right ${styles.vector}`}></i>
            </div>
          </div>
        )}
        <hr />
        <div className={styles.section}>
          <div className={styles.title}>
            <p className={textStyles['text-primary-16-600']}>Expert Help</p>
          </div>
          <div className={styles.rowBtwn} onClick={() => window.open('/experts/request-meeting')}>
            <div className={styles.row}>
              <i className="bi bi-calendar-event"></i>
              <p className={textStyles['text-primary-16-500']}>Book a meeting</p>
            </div>
            <div>
              <i className={`bi bi-chevron-right ${styles.vector}`}></i>
            </div>
          </div>
        </div>
        <hr />
        <div className={styles.section}>
          <div className={styles.title}>
            <p className={textStyles['text-primary-16-600']}>More</p>
          </div>
          <a className={styles.rowBtwn} href="https://blog.unifyapply.com/">
            <div className={styles.row}>
              <p className={textStyles['text-primary-16-500']}>Resources</p>
            </div>
            <div>
              <i className={`bi bi-chevron-right ${styles.vector}`}></i>
            </div>
          </a>
          <a className={styles.rowBtwn} href="https://blog.unifyapply.com/upcoming-webinars">
            <div className={styles.row}>
              <p className={textStyles['text-primary-16-500']}>Upcoming webinars</p>
            </div>
            <div>
              <i className={`bi bi-chevron-right ${styles.vector}`}></i>
            </div>
          </a>
          <a className={styles.rowBtwn} href="https://blog.unifyapply.com/about-us">
            <div className={styles.row}>
              <p className={textStyles['text-primary-16-500']}>About us</p>
            </div>
            <div>
              <i className={`bi bi-chevron-right ${styles.vector}`}></i>
            </div>
          </a>
        </div>
        {logged && (
          <>
            <hr />
            <div className={styles.rowBtwn} onClick={() => navigateTo('/home/account_settings')}>
              <div className={styles.row}>
                <i className="bi bi-gear"></i>
                <p className={textStyles['text-primary-16-500']}>Account setting</p>
              </div>
              <div>
                <i className={`bi bi-chevron-right ${styles.vector}`}></i>
              </div>
            </div>
            <div className={styles.rowBtwn} onClick={logout}>
              <div className={styles.row}>
                <i className="bi bi-box-arrow-right"></i>
                <p className={textStyles['text-primary-16-500']}>Logout</p>
              </div>
              <div>
                <i className={`bi bi-chevron-right ${styles.vector}`}></i>
              </div>
            </div>
          </>
        )}

        <div className={` ${styles.buttonSection}`} style={{ marginTop: logged ? '2vh' : '10vh' }}>
          {!logged && (
            <>
              <div>
                <div
                  className={`btn btn-primary ${styles.signinBtn}`}
                  onClick={() => navigateTo('/signup')}
                >
                  Sign up
                </div>
              </div>
              <div>
                <div
                  className={`btn btn-light border ${styles.loginBtn}`}
                  onClick={() => navigateTo('/login')}
                >
                  Login
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
